"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var NewMeal = function NewMeal() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "15",
    height: "20",
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.2501 19.75V10.6577C2.43857 10.482 1.75492 10.0714 1.19915 9.42593C0.64337 8.78043 0.365479\n8.01024 0.365479\n7.11538V0.25H1.86545V7.11538H3.2501V0.25H4.75005V7.11538H6.1347V0.25H7.63468V7.11538C7.63468\n8.01024 7.35679 8.78043 6.801 9.42593C6.24524 10.0714 5.56159 10.482 4.75005 10.6577V19.75L3.2501\n19.75ZM12.8655 19.75V11.75H10.1347V4.99998C10.1347 3.75128 10.5357 2.66827 11.3376 1.75095C12.1395\n0.833651 13.1488 0.339743 14.3654 0.269226V19.75H12.8655Z",
    fill: "#6E6D71"
  }));
};
var _default = NewMeal;
exports.default = _default;